import { PlanModel } from './plan.model';

export enum subscriptionStatusEnum {
    none = 'none',
    nonRenew = 'non_renewing',
    cancelled = 'cancelled',
    active = 'active',
    inTrail = 'in_trial',
    trialExpired = 'trial_expired',
    discounted = 'discounted'
}

export class UserPlanDetailModel {
    currentTermEnd: string;
    currentTermStart: string;
    nextBillingAt: string;
    plan: PlanModel;
    status: subscriptionStatusEnum
}